import { Component, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { AlertService } from '../_services/alert.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { MainService } from '../_services/main.service';
import { ClassRoomOnlineService } from '../content/system/teacher/classroom/classroom.service';


@Component({
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit {


 public breadcrumb: any;

  currentJustify = 'end';
  isLoading = true;
  classRooms: any[] = [];



  @ViewChild("modalContent", { static: true }) modalContent: TemplateRef<any>;
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  isPageLoaded = false;
  recaptchaVerifier;
  confirmationResult;
  otp;
  account;
  errMessage;
  schoolInfo: any;
  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    public authService: AuthService,
    private renderer: Renderer2,
    private modalService: NgbModal,
    private _mainService: MainService,
    private _classroomService: ClassRoomOnlineService,
    //  private spinner: NgxSpinnerService
  ) {
    // this.route.queryParams.subscribe(params => {
    //   this.returnUrl = params['returnUrl'];
    // });
    // if (!localStorage.getItem(environment.SchoolInFo)) {
    //   this._mainService.doGetSchoolInFo();
    // }
  }

  ngOnInit() {

    this.router.navigate(['/system/getallpost']);
    // this.router.navigate(['system/allpost']);
    // if (localStorage.getItem(environment.SchoolInFo) && localStorage.getItem(environment.SchoolInFo) != '') {
    //   this.schoolInfo = JSON.parse(localStorage.getItem(environment.SchoolInFo));
    // } else {
    //   this._mainService.doGetSchoolInFo().then(data => {
    //     localStorage.setItem(environment.SchoolInFo, JSON.stringify(data));
    //     this.schoolInfo = JSON.parse(localStorage.getItem(environment.SchoolInFo));
    //   })
    // }
  }

  // get f() {
  //   return this.loginForm.controls;
  // }

  // tryLogin() {

  //   var data = {
  //     mobile: this.f.mobileNo.value
  //   }
  //   alert(data.mobile);

  // }
  // addCheckbox(event) {
  //   const toggle = document.getElementById('icheckbox');
  //   if (event.currentTarget.className === 'icheckbox_square-blue') {
  //     this.renderer.addClass(toggle, 'checked');
  //   } else if (event.currentTarget.className === 'icheckbox_square-blue checked') {
  //     this.renderer.removeClass(toggle, 'checked');
  //   }
  // }
  // setUserInStorage(res) {
  //   if (res.user) {
  //     localStorage.setItem('currentUser', JSON.stringify(res.user));
  //   } else {
  //     localStorage.setItem('currentUser', JSON.stringify(res));
  //   }
  // }
  // lgIn() {
  //   this.submitted = true;

  //   // stop here if form is invalid
  //   if (this.loginForm.invalid) {
  //     return;
  //   }
  //   const value = {
  //     phonNumber: '+66' + this.f.mobileNo.value,
  //     verify: this.recaptchaVerifier
  //   };
  //   this.authService.doLogin(value).then(
  //     res => {
  //       this.modalService.open(this.modalContent);
  //       this.confirmationResult = res;

  //       console.log(res);
  //       // if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
  //       //   localStorage.setItem('remember', 'true');
  //       // } else {
  //       //   localStorage.removeItem('remember');
  //       // }
  //       // this.setUserInStorage(res);
  //       // localStorage.removeItem('currentLayoutStyle');
  //       // let returnUrl = '/dashboard/sales';
  //       // if (this.returnUrl) {
  //       //   returnUrl = this.returnUrl;
  //       // }
  //       // this.router.navigate([returnUrl]);
  //     },
  //     err => {
  //       console.log(err);
  //       this.submitted = false;
  //       this.alertService.error(err.message);
  //     }
  //   );
  // }
  // verifyOTP() {

  //   this.confirmationResult.confirm(this.otp).then(user => {
  //     if (user.user.uid == this.account.UID) {

  //       if (this.loginForm.controls['rememberMe'] && this.loginForm.controls['rememberMe'].value) {
  //         localStorage.setItem('remember', 'true');
  //       } else {
  //         localStorage.removeItem('remember');
  //       }
  //       this.setUserInStorage(this.account);
  //       localStorage.removeItem('currentLayoutStyle');

  //       window.location.href = '/member/dashboard';
  //     }

  //   }).catch(err => {
  //     this.errMessage = "ใส่รหัส OTP ไม่ถูกต้อง";
  //     if (err.message == "INVALID_CODE") {
  //       this.errMessage = "ใส่รหัส OTP ไม่ถูกต้อง";
  //     }
  //     console.log(err)
  //   })

  // }



}
